import store from '@/store/index';
import { isProPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypes } from '@/common/constants';
import MessageBox from '@zoom/zoom-ui/src/components/message-box/message-box';
import { translation } from '@/plugins/i18n';
import _ from 'lodash';
import { plansof } from '@/utils/chain';

export const preCheckZoneProPlusForBuyNow = () => {
  const getters = store.getters;

  const currentBasePlanType = getters.getCurrentBasePlanInfo.planType;

  // config baseplan is zoom one pro plus
  if (isProPlusContext && currentBasePlanType === planTypes.ZONE_PRO_PLUS) {
    const callingPlanCount = plansof(getters.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).sum('license');
    const limitLicenseWithCurrentBaseTypes = getters.limitLicenseWithCurrentBaseTypes;

    const maxBaseLicensePlans = _.filter(getters.getUserCurrentSubscriptions, item => {
      return _.includes(limitLicenseWithCurrentBaseTypes, item.type) &&
        item.cartInfo.selected_number > callingPlanCount;
    });

    if (maxBaseLicensePlans?.length) {
      const maxBaseLicensePlanNames = _.chain(maxBaseLicensePlans)
        .map((p) => translation(p.typeNameKey))
        .filter(Boolean)
        .join(',')
        .value();

      MessageBox.alert(translation('billing.licences_limit_tips',
        [maxBaseLicensePlanNames, translation('billing.zone_pro_plus.title')]),
        translation('billing.common.can_not_continue'));

      return Promise.reject();
    }
  }

  return Promise.resolve();
};
